import {
  type IRoleRepository,
  type RoleDto,
  type MenuConfigResponseDto,
  type IMenuConfigQuery,
} from "../repositories/RoleRepository";
export interface IRoleUseCase {
  getAllRoles(): Promise<RoleDto[]>;
  getRoleById(id: string): Promise<RoleDto | null>;
  getMenuConfigurations(
    query?: IMenuConfigQuery,
  ): Promise<MenuConfigResponseDto>;
}
/**
 * RoleUseCase handles business logic for role-related operations
 * Acts as an intermediary between components and the RoleRepository
 */
export class RoleUseCase implements IRoleUseCase {
  private readonly roleRepository: IRoleRepository;
  constructor(roleRepository: IRoleRepository) {
    this.roleRepository = roleRepository;
  }
  /**
   * Fetch all available roles
   */
  async getAllRoles(): Promise<RoleDto[]> {
    return await this.roleRepository.getAllRoles();
  }
  /**
   * Fetch a single role by ID
   */
  async getRoleById(id: string): Promise<RoleDto | null> {
    if (!id) {
      throw new Error("Role ID is required");
    }
    return await this.roleRepository.getRoleById(id);
  }
  /**
   * Fetch menu configurations for roles
   * Can optionally filter by specific roles
   */
  async getMenuConfigurations(
    query?: IMenuConfigQuery,
  ): Promise<MenuConfigResponseDto> {
    return await this.roleRepository.getMenuConfigurations(query);
  }
}
